import { DomainBranding, getDomainBrandingByHostname } from '@/constants/domain-branding'

// 获取域名
function useGetHostnameObj() {
  const hostname = typeof window === 'undefined' ? '' : window.location.hostname
  return getDomainBrandingByHostname(hostname)
}

export type HostNameObjType = DomainBranding

export default useGetHostnameObj
